; (function(jQuery) {

	"use strict";

	function PortalMain()
	{
		var global = {
			returnToTopBtn: jQuery('.return-to-top')
		}

		var fn = {
			init: function()
			{
				// check element is on page
				if (!global.returnToTopBtn.length)
				{
					return false;
				}

				global.returnToTopBtn.on('click', fn.scrollToTop);
			},

			scrollToTop: function()
			{
				jQuery('html, body').animate({ scrollTop: 0 }, 'slow');
			},
		}
		jQuery(fn.init);
	}

	new PortalMain();
})(jQuery);